import { CONSTANTS } from 'services/constants';
const routingPath = process.env.NODE_ENV === 'development' ? 'DEV' : 'PROD';
export function whiteLabelUrl(uri, brand = 'UJV')
{
    if (brand === 'LUXURIA')
    {
        return CONSTANTS.ROUTING[routingPath].WHITE_LABEL_LUXURIA_URL + uri;
    }

    return CONSTANTS.ROUTING[routingPath].WHITE_LABEL_URL + uri;
}

export function webInvoiceUrl(secureId, brand = 'UJV')
{
    return whiteLabelUrl(CONSTANTS.ROUTING.INVOICE_URI.replace(':secureId', secureId), brand);
}

export function webItineraryUrl(secureId, brand = 'UJV')
{
    return whiteLabelUrl(CONSTANTS.ROUTING.ITINERARY_URI.replace(':secureId', secureId), brand);
}

export function webQuoteUrl(secureId, brand = 'UJV')
{
    return whiteLabelUrl(CONSTANTS.ROUTING.QUOTE_URI.replace(':secureId', secureId), brand);
}
